import { Button, Card, Group, Stack, Text } from '@mantine/core';
import { IconExternalLink } from '@tabler/icons-react';

export function OdooAccess() {
  return <Card withBorder>
    <Group justify="space-between" align="center">
      <Stack gap={4}>
        <Text fw={600}>Facturas en Odoo</Text>
        <Text size="sm" c="dimmed">Selecciona tu base de datos y la empresa emisora en Odoo para revisar y confirmar la factura.</Text>
      </Stack>
      <Button component="a" href="https://www.odoo.com/my/databases" target="_blank" rel="noopener noreferrer" rightSection={<IconExternalLink size={16} />}>
        Abrir Odoo
      </Button>
    </Group>
  </Card>;
}
